export default "__VITE_ASSET__DxYFPGyq__"